export function formatPrice(price: number) {
  return `${price}zł`;
}
